import cx from 'classnames'
import React, { useEffect } from 'react'

import CTA from '@f/elements/CTA/CTA'

import { ExposeDownloadIcon } from '@f-fertighaus/applications/Next/components/fertighaus/Icon/ExposeDownloadIcon'

import { conversionFunnelCopy } from '../../partials/utils'

import './ExposeDownload.css'

export const ExposeDownload = props => {
  useEffect(() => {
    _wt({
      category: 'modal',
      action: 'display',
      values: [
        {
          type: 'name',
          value: 'success-expose'
        }
      ],
      flow_information: props.data.trackingInfo.flow_information
    })
  }, [])

  const handleExposeDownloadClick = () => {
    window.print()
    props.actions.closeOverlay()
  }

  return (
    <div className='RequestWizard-form-wrapper--HDP_conversion-funnel f-p-b-040'>
      <div className='expose-download_content-wrapper'>
        <div>
          <div className='[ f-t-tmedium f-c-fo-pri f-t-centre f-p-h-080:m ]'>
            {conversionFunnelCopy[props.funnelVariant].step_2.header}
          </div>
        </div>

        <div className='f-m-t-040'>
          <div className='f-d-flr f-fl-jc-ce'>
            <ExposeDownloadIcon />
          </div>
          <div className='f-t-centre '>
            <div className='f-m-t-040'>
              <p className='f-t-body'>
                Wir arbeiten gerade an dieser neuen Funktion und bieten Ihnen
                momentan eine vorläufige Version des Exposés an.
              </p>
            </div>
            <div className='f-m-t-040'>
              <p className='f-t-body'>
                Das vorläufige Exposé können Sie sich hier herunterladen:
              </p>
            </div>
          </div>
        </div>
        <div className={cx('f-m-t-040 f-m-b-020 f-t-centre')}>
          <CTA
            type='block-primary'
            tag='button'
            buttonType='button'
            data-sel='btn-cta'
            className='is-block:s'
            onClick={handleExposeDownloadClick}
            wtData={{
              'CTA-click': {
                ...props.data.trackingInfo
              }
            }}>
            {conversionFunnelCopy[props.funnelVariant].step_2.ctaText}
          </CTA>
        </div>
      </div>
    </div>
  )
}
